module.exports = __webpack_public_path__ + "img/icon_sports_surfing.8444a7d9.png";